/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { bool } from 'prop-types';
import BreadcrumbWithoutRouter from './breadcrumb-without-router';
import BreadcrumbWithRouter from './breadcrumb-with-router';
import { BASIC_DEFAULT_PROPS, BASIC_PROP_TYPES } from './util';
function Breadcrumb({ noReactRouter, ...otherProps }) {
    // Have to do this in such a tricky way because hooks can't be used conditionally
    return noReactRouter ? (React.createElement(BreadcrumbWithoutRouter, { ...otherProps })) : (React.createElement(BreadcrumbWithRouter, { ...otherProps }));
}
Breadcrumb.propTypes = {
    ...BASIC_PROP_TYPES,
    noReactRouter: bool,
};
Breadcrumb.defaultProps = {
    ...BASIC_DEFAULT_PROPS,
    noReactRouter: false,
};
export default Breadcrumb;
